<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M15.2605 22.25H8.74047C3.83047 22.25 1.73047 20.15 1.73047
     15.24V15.11C1.73047 10.67 3.48047 8.53 7.40047 8.16C7.80047 8.13 8.18047
      8.43 8.22047 8.84C8.26047 9.25 7.96047 9.62 7.54047 9.66C4.40047 9.95
       3.23047 11.43 3.23047 15.12V15.25C3.23047 19.32 4.67047 20.76 8.74047
        20.76H15.2605C19.3305 20.76 20.7705 19.32 20.7705 15.25V15.12C20.7705
         11.41 19.5805 9.93 16.3805 9.66C15.9705 9.62 15.6605 9.26 15.7005
          8.85C15.7405 8.44 16.0905 8.13 16.5105 8.17C20.4905 8.51 22.2705 10.66
           22.2705 15.13V15.26C22.2705 20.15 20.1705 22.25 15.2605 22.25Z"
      :fill="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
    <path
      d="M12 15.75C11.59 15.75 11.25 15.41 11.25 15V3.62C11.25 3.21 11.59 2.87
     12 2.87C12.41 2.87 12.75 3.21 12.75 3.62V15C12.75 15.41 12.41 15.75 12 15.75Z"
     :fill="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
    <path
      d="M15.3498 6.6C15.1598 6.6 14.9698 6.53 14.8198 6.38L11.9998 3.56L9.17984
     6.38C8.88984 6.67 8.40984 6.67 8.11984 6.38C7.82984 6.09 7.82984 5.61 8.11984
      5.32L11.4698 1.97C11.7598 1.68 12.2398 1.68 12.5298 1.97L15.8798 5.32C16.1698
       5.61 16.1698 6.09 15.8798 6.38C15.7398 6.53 15.5398 6.6 15.3498 6.6Z"
       :fill="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  props: {
    color: {
      type: String,
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
  },
};
</script>
